import React from 'react';
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./stories/store";
import * as process from 'process';

import reportWebVitals from './reportWebVitals';

import App from './App';

import 'react-toastify/dist/ReactToastify.css';
import './index.css';

window.process = process;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
        <App />
    </Provider>
);

reportWebVitals();
